import { Injectable } from '@angular/core';
import { Order } from '../../common/models/order';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { PaymentHistoryLog } from '../../common/models/PaymentHistoryLog';
import { promotions } from '../../common/config/promotions';
import { SessionManager } from '../../common/helpers/session-manager';

import * as _ from 'lodash';

@Injectable()
export class InvoiceService {

  constructor(private http: Http, private sessionManager: SessionManager) { }

  // tslint:disable-next-line:max-line-length
  createInvoice(customerId: string, order: any, status: number, paymentHistoryLog: PaymentHistoryLog, sessionId: string, IsManualProcess: boolean): Observable<any> {

    const invoiceUrl = environment.host + '/api/invoice/Create';
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    const promoCode = this.sessionManager.getPromoCode();
    //if (promoCode) {}
    const productList = _.find(promotions.products, ['promoCode', promoCode]);

    const data = JSON.stringify({
      customerId: customerId,
      invoiceOrder: order,
      status: status,
      paymentHistoryLog : paymentHistoryLog,
      sessionId : sessionId,
      isManualProcess: IsManualProcess,
      productPriceListID : productList.productPriceListId
    });

    const options = new RequestOptions({ headers: headers, withCredentials: true });
    return this.http.post(invoiceUrl, data, options)
      .map((response: any) => {
        const invoice = response.json();
        return invoice;
      })
      .catch((err) => {
        console.log(err);
        return err;
      });

  }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/services/invoice.service.ts